import { check } from '@mews-framework/utils';
import { ToLuxon } from './types';

const comparable = <T>(toLuxon: ToLuxon<T>) => {
    const isLessOrEqual = (entity1: T, entity2: T) => {
        check.sameTimezones(entity1, entity2);
        return toLuxon(entity1) <= toLuxon(entity2);
    };

    const isGreaterOrEqual = (entity1: T, entity2: T) => {
        check.sameTimezones(entity1, entity2);
        return toLuxon(entity1) >= toLuxon(entity2);
    };

    return {
        isEqual: (entity1: T, entity2: T) => {
            check.sameTimezones(entity1, entity2);
            return toLuxon(entity1).equals(toLuxon(entity2));
        },

        isLess: (entity1: T, entity2: T) => {
            check.sameTimezones(entity1, entity2);
            return toLuxon(entity1) < toLuxon(entity2);
        },

        isLessOrEqual,

        isGreater: (entity1: T, entity2: T) => {
            check.sameTimezones(entity1, entity2);
            return toLuxon(entity1) > toLuxon(entity2);
        },

        isGreaterOrEqual,

        min: (entity1: T, entity2: T) => (isLessOrEqual(entity1, entity2) ? entity1 : entity2),

        max: (entity1: T, entity2: T) => (isGreaterOrEqual(entity1, entity2) ? entity1 : entity2),
    };
};

export default comparable;
